import { FixedSizeVector } from "../fixedSizeVector";
export class LongFlatVector extends FixedSizeVector {
    getValueFromBuffer(index) {
        return this.dataBuffer[index];
    }
}
//# sourceMappingURL=longFlatVector.js.map